import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'member/activity/activity-products', // 资源路径
    defaultRels: ['productSpec', 'product'], // 默认需要的关联数据
  },
  getters: {
    collection: (state) => {
      let collection = state.collection.collection
      collection = collection.map((item) => {
        item.productSpec.photos = item.productSpec.photos.filter(photo => !photo.isDeleted)
        return item
      })
      return collection
    },
    document: state => {
      let document = state.document.document

      if (document.productSpec) {
        document.productSpec.photos = document.productSpec.photos.filter(photo => !photo.isDeleted)
      }
      return document
    }
  }
})
